import React from "react";
import {  Icons } from 'components';

const ErrorFallback = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}><Icons icon="WarningTriangle" color="#2b3990" size="60" /></div>
        <h1 style={styles.title}>خطایی رخ داده است</h1>
        <p style={styles.message}>
          متأسفانه مشکلی در بارگذاری این بخش پیش آمده است.
         
        </p>
        <button
          onClick={() => window.location.reload()}
          style={styles.button}
        >
          تلاش مجدد و بارگذاری صفحه
        </button>
      </div>
    </div>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log("error: " , error)
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("error: " , error)
    // ارسال خطا به سیستم لاگ
    if (window.tracker) {
      window.tracker.trackError({
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      });
    }
    if (window.metrics?.crash) {

      window.metrics.crash({
        message: error?.message,
        stack: error?.stack,
        metadata: {
          page: window.location.pathname,
          // user: {
          //   id: 123,
          //   name: "mohammad",
          //   email:"sharifi"
          // }
        },
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    backgroundColor: "#f4f7f9",
    fontFamily: "Tahoma, Arial, sans-serif",
    direction: "rtl",
  },
  card: {
    textAlign: "center",
    padding: "40px",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
    maxWidth: "400px",
    width: "90%",
  },
  icon: {
    fontSize: "50px",
  },
  title: {
    fontSize: "22px",
    color: "#333",
    marginBottom: "15px",
    fontWeight: "bold",
  fontFamily: 'Vazir',
  },
  message: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.6",
    marginBottom: "30px",
  },
  button: {
    backgroundColor: "#2B3990",
    color: "#fff",
    border: "none",
    padding: "12px 25px",
    borderRadius: "8px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  }
};
export default ErrorBoundary;
